import { AGENT_PLATFORM_LABELS, AGENT_PLATFORMS } from "@/domain/ai-inventory"
import {
  getInputFilter,
  getMultipleValuesFilter,
  withDisplayLabel
} from "@/helpers/filters.helper"

import { AI_POLICY_KINDS } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"

import type { TFunction } from "@/hooks/useTranslation"
import type { AiPolicySelectOption } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.types"

const LABELS = "governance.ai.live.filters"

const toOptions = (options: AiPolicySelectOption[]) =>
  options.map(({ value, label }) => ({ value, label }))

// The filters the API narrows the AI policies by, keyed as it takes them
// (AI_POLICIES_FILTER_KEYS)
export const getAiPoliciesFilters = (
  t: TFunction,
  options: {
    agents: AiPolicySelectOption[]
    toolCategories: AiPolicySelectOption[]
  }
) =>
  [
    getInputFilter("name", t, { label: `${LABELS}.name` }),
    getMultipleValuesFilter("kind", t, {
      label: `${LABELS}.kind`,
      options: AI_POLICY_KINDS.map((kind) => ({
        value: kind,
        label: t(`${LABELS}.kinds.${kind}`)
      }))
    }),
    getMultipleValuesFilter("enforcement", t, {
      label: `${LABELS}.enforcement`,
      options: [
        { value: "BLOCK", label: t("governance.ai.enforce.status.enforced") },
        { value: "MONITOR", label: t("governance.ai.enforce.status.monitor") }
      ]
    }),
    getMultipleValuesFilter("status", t, {
      label: `${LABELS}.status`,
      options: [
        { value: "enabled", label: t(`${LABELS}.enabled`) },
        {
          value: "disabled",
          label: t("governance.ai.live.statuses.disabled.label")
        }
      ]
    }),
    getMultipleValuesFilter("platform", t, {
      label: `${LABELS}.platform`,
      options: AGENT_PLATFORMS.map((platform) => ({
        value: platform,
        label: AGENT_PLATFORM_LABELS[platform]
      }))
    }),
    getMultipleValuesFilter("agentId", t, {
      label: `${LABELS}.agent`,
      options: toOptions(options.agents)
    }),
    getInputFilter("toolName", t, { label: `${LABELS}.toolName` }),
    getMultipleValuesFilter("toolCategory", t, {
      label: `${LABELS}.toolCategory`,
      options: toOptions(options.toolCategories)
    }),
    getInputFilter("connector", t, { label: `${LABELS}.connector` }),
    getInputFilter("knowledgeSource", t, {
      label: `${LABELS}.knowledgeSource`
    }),
    getMultipleValuesFilter("violation", t, {
      label: `${LABELS}.violation`,
      options: [
        { value: "violated", label: t(`${LABELS}.violated`) },
        { value: "notViolated", label: t(`${LABELS}.notViolated`) }
      ]
    })
  ].map(withDisplayLabel)
